import React from 'react';
import { useLocation } from 'react-router-dom';
import ActivityIndicator from '../activity-indicator/activity-indicator.component';
import { Center } from '../center/center.component';
import AppConstants from '../../app.constants';
import RouteConstants from '../../routes.constants';
import { useKeycloak } from '../../../features/authentication/keycloak/KeycloakProvider';

interface Props {
  readonly children: React.JSX.Element;
}

const Authenticated = ({ children }: Props): React.JSX.Element => {
  const location = useLocation();
  const keycloak = useKeycloak();

  if (keycloak.isAuthenticated && children) {
    if (location.pathname.endsWith(RouteConstants.PATH_REGISTER) || location.pathname.match(RouteConstants.PATH_DASHBOARD) != null) {
      if (keycloak.hasRealmRole(AppConstants.WHYELLOW_ROLE)) {
        return children;
      }
    } else {
      return children;
    }
  }

  return (
    <Center>
      <ActivityIndicator />
    </Center>
  );
};

export default Authenticated;
